/**
 * Returns a poll interval (in ms) only in production.
 * In non-production environments, returns undefined (no polling).
 * @param ms - The poll interval in milliseconds.
 */
export function getPollInterval(ms: number): number | undefined {
  return process.env.REACT_APP_ENVIRONMENT === 'production'
    ? ms
    : undefined;
}

/**
 * Returns a poll interval that checks visibility state at call time.
 * When the browser tab is hidden at the moment this function is called,
 * it returns 0 (which stops Apollo polling). Callers should re-invoke
 * this on each poll cycle or combine with a visibilitychange listener
 * to resume polling when the tab becomes visible again.
 * @param ms - The base poll interval in milliseconds.
 */
export function getSmartPollInterval(ms: number): number | undefined {
  if (process.env.REACT_APP_ENVIRONMENT !== 'production') {
    return undefined;
  }
  // Pause polling when tab is not visible
  if (typeof document !== 'undefined' && document.visibilityState === 'hidden') {
    return 0; // Apollo interprets 0 as "stop polling"
  }
  return ms;
}

// Email domains treated as internal VML colleagues (self-register + auto-provision).
export const INTERNAL_EMAIL_DOMAINS = ['@vml.com', '@es.wpp.com'];

/**
 * Whether the given email belongs to an internal VML domain.
 * @param email - The email address to check.
 */
export function isInternalEmail(email: string): boolean {
  const normalized = email.trim().toLowerCase();
  return INTERNAL_EMAIL_DOMAINS.some((domain) => normalized.endsWith(domain));
}
